import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React from "react";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
	labels: ["LP (10%)", "Presale (50%)", "CEX (10%)","Team (10%)","Marketing (10%)"],
	datasets: [
		{
			data: [10, 50, 10,10,10],
			backgroundColor: ["#8e53f6", "#9a67ea", "#a67ade","#b28fd0","#28d6a5"],
			borderWidth: 0,
		},
	],
};

const TokenChart = () => {
	return (
		<div className="d-flex justify-content-center">
			<div
				style={{
					width: "320x",
					height: "320px",
				}}
			>
				<Doughnut data={data} />
			</div>

		</div>
	);
};
export default TokenChart;
